module.exports = __webpack_public_path__ + "img/code.7acbe371.jpg";